import { render, staticRenderFns } from "./addHomeSupport.vue?vue&type=template&id=4fc039bf&scoped=true"
import script from "./addHomeSupport.vue?vue&type=script&lang=js"
export * from "./addHomeSupport.vue?vue&type=script&lang=js"
import style0 from "./addHomeSupport.vue?vue&type=style&index=0&id=4fc039bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc039bf",
  null
  
)

export default component.exports